var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.016 6h4.969v2.016h-3v9q0 1.219-0.891 2.109t-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891q0.375 0 1.031 0.188v-8.203zM3 15.984v-1.969h8.016v1.969h-8.016zM15 9.984v2.016h-12v-2.016h12zM15 6v2.016h-12v-2.016h12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayQueue);
export default __webpack_public_path__ + "static/media/play_queue.e83b8235f99296a49b243334db83fb94.svg";
export { ForwardRef as ReactComponent };